import { createContext } from 'react';
import { DownloadSource } from 'models/MixpanelEvents';
import utils from 'utils';

type DesktopAppContextProps = {
  downloadLink: string;
  trackDownload: (
    downloadSource: DownloadSource,
    dataRoomId: string,
    dataRoomName: string,
  ) => void;
};

export default createContext<Partial<DesktopAppContextProps>>({
  downloadLink: '',
  trackDownload: utils.noop,
});
